import { ApolloLink } from "@apollo/client";
import { getUserDistinctId } from "@crehana/utils";
const distinctIdLink = new ApolloLink((operation, forward)=>{
    let distinctId = '';
    if ("u" > typeof window) distinctId = getUserDistinctId().distinctId;
    operation.setContext(({ headers = {} })=>({
            headers: {
                ...headers,
                'session-distinct-id': distinctId
            }
        }));
    return forward(operation);
});
const links_distinctIdLink = distinctIdLink;
export default links_distinctIdLink;
